﻿import React from 'react';

const LoadingScreenWidget = () => {
  return (
    <div className="facilitysearchpage__loader">
      <div className="aimo-spinner"><span></span><span></span><span></span><span></span></div>
    </div>
  )
}

export default LoadingScreenWidget;
